/**
 * Centralized toast notification hook.
 *
 * Replaces duplicated toast state management across portal pages:
 * - PortalInboxPage
 * - PortalOrdersPage
 * - GmailAdminPage (doesn't use this pattern - uses different toast UI)
 * - OrdersPage (doesn't use this pattern - uses different toast UI)
 */

import { useState, useCallback } from 'react';

export type ToastType = 'success' | 'warning' | 'error';

export interface ToastMessage {
  id: number;
  message: string;
  type: ToastType;
}

export function useToast() {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const addToast = useCallback((message: string, type: ToastType = 'success') => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, type }]);
  }, []);

  const removeToast = useCallback((id: number) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return { toasts, addToast, removeToast };
}
